// extracted by mini-css-extract-plugin
export var dragging = "sfxJz";
export var horizontal = "lMKbQ";
export var resizeHandle = "zzOrI";
export var vertical = "t1VdD";